import { cx } from "../../utils/functions";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.JSX.Element | React.JSX.Element[] | string;
  variant?: "primary" | "accent";
  className?: string;
}

export const Badge = ({ children, variant, className, ...props }: BadgeProps) => {
  return (
    <div
      className={cx(
        "badge text-nowrap",
        variant === "accent" && "badge-accent",
        variant === "primary" && "bg-[var(--l0-badge-color)] text-[var(--color-base-content)]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
